// extracted by mini-css-extract-plugin
module.exports = {"root":"selectMode_root__5Kc6q","btn":"selectMode_btn__1Q_ov","select_btn":"selectMode_select_btn__2-uev"};